import { OrderViewPriceDetailsListItemWrapper } from './OrderViewPriceDetailsListItem.styles';
import OrderViewPriceDetailsListItemTitle from './OrderViewPriceDetailsListItemTitle';
import OrderViewPriceDetailsListItemRow, {
  PriceDetailsItem,
} from './OrderViewPriceDetailsListItemRow';

const OrderViewPriceDetailsListItem = ({
  title,
  priceDetailsItems,
}: {
  title: string;
  priceDetailsItems: PriceDetailsItem[];
}) => {
  return (
    <OrderViewPriceDetailsListItemWrapper>
      <OrderViewPriceDetailsListItemTitle title={title} />
      {priceDetailsItems
        .filter((item) => !!item)
        .map(({ label, amount, ...props }, index) => (
          <OrderViewPriceDetailsListItemRow
            label={label}
            amount={amount}
            // Index required for unique keys when rows have identical name+amount (e.g. duplicate-named fees from API)
            key={`${title}-${index}-${
              typeof label === 'object' && label !== null && 'key' in label
                ? (label as { key: string }).key
                : String(label)
            }`}
            {...props}
          />
        ))}
    </OrderViewPriceDetailsListItemWrapper>
  );
};

export default OrderViewPriceDetailsListItem;
